/**
 *  Home.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 06/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

// template
import { Grid, Row, Col } from "react-bootstrap";

// components
import Loading from "../Loader/Loader.jsx";
import { darkModeStyle, icon, whiteModeStyle } from "./Variables.jsx";

// style
import "./style.css";

// redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { saveUsers } from '../../actions/users';

// Maps
import { compose, withProps } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";

// global
var firebase = require("../../firebase");
var utils = require("../../utils");

class Home extends Component {
  
    constructor(props) {
        super(props);

        this.state = {
            commons: [],
            loading: false,
            showAlert: false,
            defLat: -26.3044,
            defLong: -48.8464
        };
    }

    componentWillMount() {
        document.title = "Security Care | Monitoramento";
    }

    componentDidMount() {
        this.getGeoLocation()
        this.setState({ loading: true}, () => {
            this.getUsers();
        });
    }

    getUsers = _ => {
        const { saveUsers } = this.props;

        firebase.database.ref('users').orderByChild("createdAt").once('value').then((snap) => {
            saveUsers(snap.val());

            setTimeout(() => {
                firebase.database.ref("locationUsers").once('value').then((snaps) => {
                    let value = snaps.val();
                    if(value) {
                        this.getLocation(Object.assign(value));
                    } else {
                        this.setState({ commons: [] }, _ => {
                            this.getMarkers();
                        })
                    }
                });
            }, 1000);
        });
    }

    getLocation = (locationUsers) => {
        const { users } = this.props
        let commons = []
        
        for(const key in locationUsers) {
            const userLocation = locationUsers[key]
            const value = userLocation ? userLocation.l : []

            if(users && users[key] && Array.isArray(value) && value.length >= 2) {
                commons.push({
                    lat: value[0],
                    long: value[1],
                    info: users[key]
                });
            }
        }
        
        this.setState({ commons }, _ => {
            this.getMarkers();
        })
    }

    getMarkers = () => {
        const { commons } = this.state
        let markers = []

        for (var key in commons) {
            let common = commons[key];
            markers.push(<Marker position={{ lat: common.lat, lng: common.long }}  icon={icon} />)
        }
        
        this.setState({ markers }, () => {
            this.setState({loading: false});
        });
    }

    getGeoLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            position => {
              this.setState({
                defLat: position.coords.latitude,
                defLong: position.coords.longitude
              })
            }
          )
        } else {
          error => console.log(error)
        }
      }

    render() {
        const { loading, defLat, defLong } = this.state;

        const MyMapComponent = compose(
            withProps({
                    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDtfgAc1X2E0xI3pGsVl_kjKglZsg5vwdA&v=3.exp&libraries=geometry,drawing,places",
                    loadingElement: <div style={{ height: `100%` }} />,
                    loadingElement: <div style={{ height: `100%` }} />,
                    containerElement: <div style={{ height: `100%` }} />,
                    mapElement: <div style={{ height: `100%` }} />,
                }),
                withScriptjs,
                withGoogleMap
                )((props) =>
                <GoogleMap
                    defaultZoom={14}
                    defaultCenter={{ lat:  defLat, lng: defLong }}
                    options={{
                        styles: whiteModeStyle,
                    }}
                >                                                           
                    {this.state.markers}
                </GoogleMap>
            )

        return (
            <div className="content content-a">
                { loading && <Loading /> }

                <Grid fluid>
                    {!loading && <MyMapComponent />}
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    users: store.users.users
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ saveUsers }, dispatch);

export default connect (mapStateToProps, mapDispatchToProps)(withRouter(Home));








// WEBPACK FOOTER //
// ./src/views/Home/Home.jsx